import { NotStartedOutlined } from '@mui/icons-material';
import { useAtom } from 'jotai';
import { useLocation } from 'react-router';

import { parsePathname } from '../../app/appHeader/path-utils';
import { usePatientAnalysisHistorical } from '../../react-query/usePatientAnalysisHistorical';
import { useAppContext } from '../../utils/hooks/useAppContext';
import { selectUnifiedIdAtom } from '../patientList/atoms';

import {
  EnqueueHistoricalImages,
  HistoricalImagesContainer,
  ProcessingStatus,
  ProcessingStatusContainer,
} from './subcomponents';

export const CheckForHistoricalImages = () => {
  const { user } = useAppContext();
  const { pathname, search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const source = urlParams.get('source') || 'huddle';
  const patientIdFromUrl = urlParams.get('patientId');
  const { patientId } = parsePathname(pathname);
  const patientIdFallback = patientIdFromUrl || patientId;
  const returnRoute =
    source === 'huddle' ? '/uploader' : `/annotator/${patientIdFallback}`;
  const { primaryPracticeId, primaryOrganizationId } = user;
  const [selectUnifiedId] = useAtom(selectUnifiedIdAtom);

  const response = usePatientAnalysisHistorical({
    unifiedId: selectUnifiedId,
    primaryPracticeId,
    primaryOrganizationId,
  });
  const { data: responseData, isFetched } = response;
  let hasHistoricalImages = false;
  let isHistoricalImagesDone = false;

  if (isFetched && Array.isArray(responseData) && responseData.length > 0) {
    const [data] = responseData || [];
    const { patientId: imagingPatientId, data: historicalData } = data;
    hasHistoricalImages = historicalData.some(
      (analysis: { status: string }) => analysis.status !== 'COMPLETE',
    );
    isHistoricalImagesDone =
      historicalData.length > 0 &&
      historicalData.every(
        (analysis: { status: string }) => analysis.status === 'COMPLETE',
      );

    return (
      <HistoricalImagesContainer>
        {hasHistoricalImages && !isHistoricalImagesDone ? (
          <EnqueueHistoricalImages
            imagingPatientId={imagingPatientId}
            returnRoute={returnRoute}
          />
        ) : (
          <ProcessingStatus response={response} returnRoute={returnRoute} />
        )}
      </HistoricalImagesContainer>
    );
  }
  if (isFetched && Array.isArray(responseData) && responseData.length === 0) {
    return (
      <ProcessingStatusContainer
        status="error"
        icon={<NotStartedOutlined />}
        message="No un-analyzed historical images for this patient."
        returnRoute={returnRoute}
      />
    );
  }
  return (
    <ProcessingStatusContainer
      status="error"
      icon={<NotStartedOutlined />}
      message="Error processing historical images. Please contact support."
      returnRoute={returnRoute}
    />
  );
};
